import { ActivatedRouteSnapshot } from '@angular/router';

/** Takes a route snapshot and gets the 'leaf' route by traversing the path. */
export function getDeepestActivatedRoute(route: ActivatedRouteSnapshot) {
  while (route.firstChild) {
    route = route.firstChild;
  }
  return route;
}
